export default "__VITE_ASSET__CDwDg3y4__"